/**
 * Function for checking the length of password
 */
import { PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY, USER_MANAGEMENT_STORE } from "../common/constant";
import { beginLoading, endLoading } from "./loadingSpinner";
import { clearMessages, createErrorMessages, createBackendErrorMessages, messagesReceived } from "./message";

import ModalDialogUtil from "../utils/ModalDialogUtil";
import ObjectUtils from "../utils/ObjectUtils";
import { reloadFundingAreaList } from "./fundingArea";
import rest from "../common/rest";
import { showDialog } from "./confirmDialog";

const REDUCER = "USERS.";

const LOAD_USERS_ACTION = REDUCER + "LOAD_USERS_ACTION";
const CHANGE_PAGINATION_PAGE_FOR_USER_MANAGEMENT = REDUCER + "CHANGE_PAGINATION_PAGE_FOR_USER_MANAGEMENT";
const PROPERTY_CHANGED_ACTION = REDUCER + "PROPERTY_CHANGED_ACTION";
const PREPARE_USER_DATA_FOR_EDITING_ACTION = REDUCER + "PREPARE_USER_DATA_FOR_EDITING_ACTION";
const LOAD_ROLES_ACTION = REDUCER + "LOAD_ROLES_ACTION";
const MOVE_ROLE_ACTION = REDUCER + "MOVE_ROLE_ACTION";
const PASSWORD_IS_VALID_ACTION = REDUCER + "PASSWORD_IS_VALID_ACTION";
const USERNAME_IS_VALID_ACTION = REDUCER + "USERNAME_IS_VALID_ACTION";
const CHANGE_SORT_PROPERTIES_ACTION = REDUCER + "CHANGE_SORT_PROPERTIES_ACTION";

export const LOADED = "loaded";
export const ROLE_LIST_LOAD_REQUEST = REDUCER + "ROLE_LIST_LOAD_REQUEST";
export const ROLE_LIST_LOAD_SUCCESS = REDUCER + "ROLE_LIST_LOAD_SUCCESS";
export const ROLE_LIST_LOAD_FAIL = REDUCER + "ROLE_LIST_LOAD_FAIL";

export const USER_PARTICIPATIONS_LOAD_REQUEST = REDUCER + "USER_PARTICIPATIONS_LOAD_REQUEST";
export const USER_PARTICIPATIONS_LOAD_SUCCESS = REDUCER + "USER_PARTICIPATIONS_LOAD_SUCCESS";
export const USER_PARTICIPATIONS_LOAD_FAIL = REDUCER + "USER_PARTICIPATIONS_LOAD_FAIL";

export const USER_PARTICIPATIONS_BY_USER_LOAD_REQUEST = REDUCER + "USER_PARTICIPATIONS_BY_USER_LOAD_REQUEST";
export const USER_PARTICIPATIONS_BY_USER_LOAD_SUCCESS = REDUCER + "USER_PARTICIPATIONS_BY_USER_LOAD_SUCCESS";
export const USER_PERMISSION_HISTORY_LOAD_REQUEST = REDUCER + "USER_PERMISSION_HISTORY_LOAD_REQUEST";
export const USER_PERMISSION_HISTORY_LOAD_SUCCESS = REDUCER + "USER_PERMISSION_HISTORY_LOAD_SUCCESS";
export const USER_PERMISSION_HISTORY_LOAD_FAIL = REDUCER + "USER_PERMISSION_HISTORY_LOAD_FAIL";

const VALUE = "value";
export const PAGINATION_LINKS = "paginationLinks";
export const USERS = "users";
export const USER_TABLE_PAGE = "userTablePage";
export const CREATE_NEW_USER_DIALOG = "createNewUserDialog";
export const EDIT_USER_DIALOG = "editUserDialog";
export const CHANGE_USER_STATUS_DIALOG = "changeUserStatusDialog";
export const USER_ALREADY_EXISTS = "userAlreadyExists";
export const USERNAME = "username";
export const EMPLOYEE_NUMBER = "employeeNumber";
export const FIRSTNAME = "firstname";
export const LASTNAME = "lastname";
export const PASSWORD = "password";
export const ROLES = "roles";
export const USER_ROLES = "userRoles";
export const USER_PARTICIPATIONS = "userParticipations";
export const USER_PARTICIPATIONS_BY_USER = "userParticipationsByUser";
export const USER_PERMISSION_HISTORY = "userPermissionHistory";
export const USER_PERMISSION_HISTORY_LOADING = "userPermissionHistoryLoading";
export const ACTIVE = "active";
export const SORT_USER_TABLE_BY = "sortUserTableBy";
export const SORT_USER_TABLE_ORDER = "sortUserTableOrder";
export const CURRENT_PASSWORD_IS_VALID = "currentPasswordIsValid";
export const CURRENT_USERNAME_IS_VALID = "currentUsernameIsValid";
export const ROLE_LIST = "roleList";
export const SEND_USER_NOTIFICATION = "sendUserNotification";

const CURRENT_USER_ID = "currentUserId";
const AVAILABLE_ROLES = "availableRoles";
export const LOCAL_ROLES = "localRoles";
const ACTIVATE_ROLE = "activateRole";
const ROLE = "role";
const CONTENT = "content";
export const NUMBER_OF_USERS_PER_PAGE = "numberOfUserPerPage";
export const ACTIVE_USERS_ONLY = "activeOnly";
export const UNNOTIFIED_USERS_ONLY = "unnotifiedUsersOnly";
const ENDPOINT_LINK = "endpointLink";

export const MIN_PASSWORD_CHARS = 8;
export const MAX_PASSWORD_CHARS = 20;

export const FA_TARGET_NAME = "userManagament";

const initialState = {
  [ROLE_LIST]: [],
  [USERS]: [],
  [CREATE_NEW_USER_DIALOG]: false,
  [EDIT_USER_DIALOG]: false,
  [CHANGE_USER_STATUS_DIALOG]: false,
  [SORT_USER_TABLE_ORDER]: "asc",
  [USERNAME]: "",
  [FIRSTNAME]: "",
  [EMPLOYEE_NUMBER]: "",
  [LASTNAME]: "",
  [PASSWORD]: "",
  [USER_ROLES]: [],
  [USER_PARTICIPATIONS]: [],
  [USER_PARTICIPATIONS_BY_USER]: {},
  [USER_PERMISSION_HISTORY]: [],
  [USER_PERMISSION_HISTORY_LOADING]: false,
  [SORT_USER_TABLE_BY]: "",
  [ACTIVE]: true,
  [CURRENT_PASSWORD_IS_VALID]: true,
  [CURRENT_USERNAME_IS_VALID]: true,
  [USER_ALREADY_EXISTS]: false,
  [ENDPOINT_LINK]: null,
  [NUMBER_OF_USERS_PER_PAGE]: 0,
  [ACTIVE_USERS_ONLY]: true,
  [UNNOTIFIED_USERS_ONLY]: false,
  [SEND_USER_NOTIFICATION]: true
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case LOAD_USERS_ACTION:
      newState = Object.assign({}, state, {
        [PAGINATION_LINKS]: handlePaginationLinks(action[VALUE]["links"]),
        [USERS]: action[VALUE],
        [USER_TABLE_PAGE]: action[VALUE]["page"]
      });
      break;
    case CHANGE_PAGINATION_PAGE_FOR_USER_MANAGEMENT:
      newState = Object.assign({}, state, {
        [PAGINATION_LINKS]: handlePaginationLinks(action[VALUE]["links"]),
        [USERS]: action[VALUE],
        [USER_TABLE_PAGE]: action[VALUE]["page"]
      });
      break;
    case PROPERTY_CHANGED_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;

    case PASSWORD_IS_VALID_ACTION:
      newState = Object.assign({}, state, {
        [CURRENT_PASSWORD_IS_VALID]: action[CURRENT_PASSWORD_IS_VALID]
      });
      break;
    case USERNAME_IS_VALID_ACTION:
      newState = Object.assign({}, state, {
        [CURRENT_USERNAME_IS_VALID]: action[CURRENT_USERNAME_IS_VALID]
      });
      break;
    case PREPARE_USER_DATA_FOR_EDITING_ACTION:
      newState = Object.assign({}, state, {
        [USERNAME]: action[USERNAME],
        [FIRSTNAME]: action[FIRSTNAME],
        [LASTNAME]: action[LASTNAME],
        [PASSWORD]: action[PASSWORD],
        [EMPLOYEE_NUMBER]: action[EMPLOYEE_NUMBER],
        [CURRENT_USER_ID]: action[CURRENT_USER_ID],
        [ACTIVE]: action[ACTIVE],
        [USER_ROLES]: action[USER_ROLES],
        [USER_ALREADY_EXISTS]: action[USER_ALREADY_EXISTS],
        [CURRENT_PASSWORD_IS_VALID]: action[CURRENT_PASSWORD_IS_VALID],
        [LOCAL_ROLES]: removeAlreadyUsedRoles(state[AVAILABLE_ROLES], action[USER_ROLES]),
        [USER_PARTICIPATIONS]: action[USER_PARTICIPATIONS]
      });
      break;
    case LOAD_ROLES_ACTION:
      newState = Object.assign({}, state, {
        [AVAILABLE_ROLES]: action[VALUE][CONTENT],
        [LOCAL_ROLES]: action[VALUE][CONTENT]
      });
      break;
    case MOVE_ROLE_ACTION:
      let newRoles = handleMovingRole(state[LOCAL_ROLES], state[USER_ROLES], action);
      newState = Object.assign({}, state, {
        [USER_ROLES]: newRoles[USER_ROLES],
        [LOCAL_ROLES]: newRoles[LOCAL_ROLES]
      });
      break;
    case CHANGE_SORT_PROPERTIES_ACTION:
      newState = Object.assign({}, state, {
        [SORT_USER_TABLE_BY]: action[SORT_USER_TABLE_BY],
        [SORT_USER_TABLE_ORDER]: action[SORT_USER_TABLE_ORDER]
      });
      break;
    case ROLE_LIST_LOAD_SUCCESS:
      newState = {
        ...state,
        [ROLE_LIST]: action[ROLE_LIST]
      };
      break;
    case USER_PARTICIPATIONS_LOAD_SUCCESS:
      newState = {
        ...state,
        [USER_PARTICIPATIONS]: action[USER_PARTICIPATIONS],
        [EMPLOYEE_NUMBER]: action[EMPLOYEE_NUMBER]
      };
      break;
    case USER_PARTICIPATIONS_BY_USER_LOAD_SUCCESS:
      newState = {
        ...state,
        [USER_PARTICIPATIONS_BY_USER]: { ...state[USER_PARTICIPATIONS_BY_USER], ...action[USER_PARTICIPATIONS_BY_USER] }
      };
      break;
    case USER_PERMISSION_HISTORY_LOAD_REQUEST:
      newState = {
        ...state,
        [USER_PERMISSION_HISTORY]: [],
        [USER_PERMISSION_HISTORY_LOADING]: true
      };
      break;
    case USER_PERMISSION_HISTORY_LOAD_SUCCESS:
      newState = {
        ...state,
        [USER_PERMISSION_HISTORY]: action[USER_PERMISSION_HISTORY],
        [USER_PERMISSION_HISTORY_LOADING]: false
      };
      break;
    case USER_PERMISSION_HISTORY_LOAD_FAIL:
      newState = {
        ...state,
        [USER_PERMISSION_HISTORY]: [],
        [USER_PERMISSION_HISTORY_LOADING]: false
      };
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }

  return newState;
}

function handleMovingRole(localRoles, roles, action) {
  let userRoles = ObjectUtils.deepClone(roles);
  let newUserRole = {
    identifier: action[ROLE]["identifier"],
    name: action[ROLE]["name"]
  };
  if (action.activateRole) {
    userRoles.push(newUserRole);
    localRoles = ObjectUtils.removeObjectByProp(localRoles, "identifier", newUserRole.identifier);
  } else {
    localRoles.push(newUserRole);
    userRoles = ObjectUtils.removeObjectByProp(roles, "identifier", newUserRole.identifier);
  }
  return {
    [USER_ROLES]: userRoles,
    [LOCAL_ROLES]: localRoles
  };
}

export function checkPasswordLength(password) {
  let valid = password.length >= MIN_PASSWORD_CHARS && password.length <= MAX_PASSWORD_CHARS;
  return {
    [TYPE_KEY]: PASSWORD_IS_VALID_ACTION,
    [CURRENT_PASSWORD_IS_VALID]: valid
  };
}

export function checkUsername(username) {
  let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  let valid = re.test(username);
  return {
    [TYPE_KEY]: USERNAME_IS_VALID_ACTION,
    [CURRENT_USERNAME_IS_VALID]: valid
  };
}

/**
 * Function call server for list of users.
 */
export function loadUsers(stopLoading = false) {
  return (dispatch, getState) => {
    dispatch(beginLoading());
    const { endpointLink, sortUserTableBy, sortUserTableOrder, activeOnly, unnotifiedUsersOnly } =
      getState()[USER_MANAGEMENT_STORE];
    let request = endpointLink
      ? `${endpointLink}`
      : `/authentication/users?sort=${sortUserTableBy},${sortUserTableOrder}`;
    if (activeOnly) {
      request = request.concat("&activeUsers=true");
    }

    if (unnotifiedUsersOnly) {
      request = request.concat("&unnotifiedUsersOnly=true");
    }

    rest.doGet(request).then(
      (json) => {
        if (json) {
          // @todo: filtering in backend
          if (activeOnly) {
            const activeUsers = json.filter((user) => user.active === true);
            json = activeUsers;
          }

          dispatch(loadUsersParticipations(json.map((u) => u.username)));
          dispatch(loadSuccessful(json, LOAD_USERS_ACTION));
          if (stopLoading) {
            dispatch(endLoading());
          }
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 * Function call server for list of users.
 */
export function functionSwitchPage(page) {
  return (dispatch, getState) => {
    const { sortUserTableBy, sortUserTableOrder, numberOfUserPerPage } = getState()[USER_MANAGEMENT_STORE];
    rest
      .doGet(
        `/authentication/users?sort=${sortUserTableBy},${sortUserTableOrder}&size=${numberOfUserPerPage}&page=${page}`
      )
      .then(
        (json) => {
          if (json) {
            dispatch(loadSuccessful(json, CHANGE_PAGINATION_PAGE_FOR_USER_MANAGEMENT));
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
          }
        },
        (reason) => {
          dispatch(messagesReceived(createBackendErrorMessages(reason)));
        }
      );
  };
}

/**
 * Function for saving a new user.
 */
export function createNewUser() {
  return (dispatch, getState) => {
    dispatch(beginLoading());
    const { username, firstname, lastname, employeeNumber, roleList, sendUserNotification } = getState()[USER_MANAGEMENT_STORE];
    dispatch(propertyChange(USER_ALREADY_EXISTS, false));
    //dispatch(checkPasswordLength(password));
    dispatch(propertyChange(CURRENT_PASSWORD_IS_VALID, true));

    dispatch(checkUsername(username));

    if (getState().userManagement[CURRENT_USERNAME_IS_VALID]) {
      const participations = getState()[USER_MANAGEMENT_STORE][USER_PARTICIPATIONS] || [];
      participations.forEach((part) => {
        delete part.unit.programs;
        delete part.unit.programInstances;
        delete part.unit.projects;
        delete part.unit.fundingArea;
        delete part.unit.program;
        delete part.unit.programInstance;
      });

      const effectiveRolesMap = {};
      participations.forEach((participation) => {
        const resolvedRole = roleList.find((r) => r.name === participation.role);

        effectiveRolesMap[resolvedRole.name] = {
          identifier: resolvedRole.id,
          name: resolvedRole.name
        };
      });

      const effectiveRoles = Object.values(effectiveRolesMap);

      let user = {
        [FIRSTNAME]: firstname,
        [LASTNAME]: lastname,
        [USERNAME]: username,
        [EMPLOYEE_NUMBER]: employeeNumber,
        [PASSWORD]: "P@ssw0rd0211",
        [ROLES]: effectiveRoles,
        participations: participations
      };
      rest.doPost(`/admin/users?sendUserNotification=${sendUserNotification}`, JSON.stringify(user)).then(
        (json) => {
          if (json) {
            dispatch(loadUsers());
            dispatch(propertyChange(CREATE_NEW_USER_DIALOG, false));
            dispatch(propertyChange(CURRENT_PASSWORD_IS_VALID, true));
            dispatch(endLoading());
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
            dispatch(endLoading());
          }
        },
        (reason) => {
          dispatch(messagesReceived(createErrorMessages("user.management.create.new.user.exists.warning")));
          dispatch(endLoading());
          if (reason.status === 400) {
            dispatch(propertyChange(USER_ALREADY_EXISTS, true));
            dispatch(propertyChange(CURRENT_PASSWORD_IS_VALID, true));
          }
        }
      );
    } else {
      dispatch(propertyChange(CURRENT_PASSWORD_IS_VALID, false));
      dispatch(endLoading());
    }
  };
}

/**
 * Function for editing a user.
 */
export function editUser() {
  return (dispatch, getState) => {
    const { username, firstname, lastname, password, employeeNumber, active, currentUserId, roleList } =
      getState()[USER_MANAGEMENT_STORE];

    //password !== null && password !== "" ? dispatch(checkPasswordLength(password)) :
    // dispatch(propertyChange(CURRENT_PASSWORD_IS_VALID, true));
    dispatch(propertyChange(CURRENT_PASSWORD_IS_VALID, true));

    if (getState()[USER_MANAGEMENT_STORE][CURRENT_PASSWORD_IS_VALID]) {
      const participations = getState()[USER_MANAGEMENT_STORE][USER_PARTICIPATIONS] || [];
      participations.forEach((part) => {
        delete part.unit.programs;
        delete part.unit.programInstances;
        delete part.unit.projects;
        delete part.unit.fundingArea;
        delete part.unit.program;
        delete part.unit.programInstance;
      });

      const effectiveRolesMap = {};
      participations.forEach((participation) => {
        const resolvedRole = roleList.find((r) => r.name === participation.role);

        effectiveRolesMap[resolvedRole.name] = {
          identifier: resolvedRole.id,
          name: resolvedRole.name
        };
      });

      const effectiveRoles = Object.values(effectiveRolesMap);

      let user = {
        [FIRSTNAME]: firstname,
        [LASTNAME]: lastname,
        [USERNAME]: username,
        [EMPLOYEE_NUMBER]: employeeNumber,
        [PASSWORD]: password,
        [ROLES]: effectiveRoles,
        [ACTIVE]: active,
        participations: participations
      };

      const payload = JSON.stringify(user);

      rest.doPut(`/admin/users/${currentUserId}`, payload).then(
        (json) => {
          if (json) {
            ModalDialogUtil.closeModalDialogBodyFix();
            dispatch(loadUsers());
            dispatch(propertyChange(EDIT_USER_DIALOG, false));
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
          }
        },
        (reason) => {
          dispatch(messagesReceived(createBackendErrorMessages(reason)));
        }
      );
    } else {
      dispatch(propertyChange(CURRENT_PASSWORD_IS_VALID, false));
    }
  };
}

/**
 * Function call server for list of users.
 */
export function loadAvailableRoles() {
  return (dispatch) => {
    rest.doGet(`/authentication/roles`).then(
      (json) => {
        if (json) {
          dispatch(loadSuccessful(json, LOAD_ROLES_ACTION));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function changeSortingProperties(sortUserTableBy, sortUserTableOrder) {
  return {
    [TYPE_KEY]: CHANGE_SORT_PROPERTIES_ACTION,
    [SORT_USER_TABLE_BY]: sortUserTableBy,
    [SORT_USER_TABLE_ORDER]: sortUserTableOrder
  };
}

function loadSuccessful(data, actionType) {
  return {
    [TYPE_KEY]: actionType,
    [VALUE]: data
  };
}

export function propertyChange(propertyName, propertyValue) {
  return {
    [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
    [PROPERTY_NAME]: propertyName,
    [PROPERTY_VALUE]: propertyValue
  };
}

export function prepareUserDataForEditing(user) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: PREPARE_USER_DATA_FOR_EDITING_ACTION,
      [USERNAME]: user[USERNAME],
      [FIRSTNAME]: user[FIRSTNAME],
      [LASTNAME]: user[LASTNAME],
      [PASSWORD]: user[PASSWORD],
      [EMPLOYEE_NUMBER]: user[EMPLOYEE_NUMBER],
      [CURRENT_USER_ID]: user["identifier"],
      [ACTIVE]: user[ACTIVE],
      [USER_ROLES]: user[ROLES],
      [CURRENT_PASSWORD_IS_VALID]: true,
      [USER_PARTICIPATIONS]: []
    });
    dispatch(loadUserParticipations(user[USERNAME]));
    dispatch(clearMessages());
  };
}

export function cleanUserData() {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: PREPARE_USER_DATA_FOR_EDITING_ACTION,
      [USERNAME]: "",
      [FIRSTNAME]: "",
      [LASTNAME]: "",
      [EMPLOYEE_NUMBER]: "",
      [PASSWORD]: "",
      [CURRENT_USER_ID]: "",
      [USER_ALREADY_EXISTS]: false,
      [CURRENT_PASSWORD_IS_VALID]: true,
      [ACTIVE]: false,
      [USER_ROLES]: [],
      [USER_PARTICIPATIONS]: [],
      [SEND_USER_NOTIFICATION]: true
    });
    dispatch(clearMessages());
  };
}

function handlePaginationLinks(linksFromServer) {
  let linksArray = [];
  if (linksFromServer) {
    for (let i = 0; i < linksFromServer.length; i++) {
      linksArray[linksFromServer[i]["rel"]] = linksFromServer[i]["href"];
    }
  }
  return linksArray;
}

export function onHandleFirst() {
  return (dispatch, getState) => {
    dispatch(propertyChange(ENDPOINT_LINK, getState()[USER_MANAGEMENT_STORE][PAGINATION_LINKS].first));
    dispatch(loadUsers());
  };
}

export function onHandlePrev() {
  return (dispatch, getState) => {
    dispatch(propertyChange(ENDPOINT_LINK, getState()[USER_MANAGEMENT_STORE][PAGINATION_LINKS].prev));
    dispatch(loadUsers());
  };
}

export function onHandleNext() {
  return (dispatch, getState) => {
    dispatch(propertyChange(ENDPOINT_LINK, getState()[USER_MANAGEMENT_STORE][PAGINATION_LINKS].next));
    dispatch(loadUsers());
  };
}

export function onHandleLast() {
  return (dispatch, getState) => {
    dispatch(propertyChange(ENDPOINT_LINK, getState()[USER_MANAGEMENT_STORE][PAGINATION_LINKS].last));
    dispatch(loadUsers());
  };
}

export function moveRole(role, activate) {
  return {
    [TYPE_KEY]: MOVE_ROLE_ACTION,
    [ROLE]: role,
    [ACTIVATE_ROLE]: activate
  };
}

function removeAlreadyUsedRoles(localRoles, roles) {
  let notUsedRoles = ObjectUtils.deepClone(localRoles);
  for (let i = 0; i < roles.length; i++) {
    notUsedRoles = ObjectUtils.removeObjectByProp(notUsedRoles, "identifier", roles[i]["identifier"]);
  }
  return notUsedRoles;
}

export function loadMasterData() {
  return (dispatch) => {
    dispatch(reloadFundingAreaList(FA_TARGET_NAME));
    dispatch(loadRoles());
  };
}

export function loadRoles() {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: ROLE_LIST_LOAD_REQUEST });

    rest.doGet(`/authentication/roles?simple=true`).then((roleList) => {
      dispatch({
        [TYPE_KEY]: ROLE_LIST_LOAD_SUCCESS,
        [ROLE_LIST]: roleList
      });
    });
  };
}

export function loadUserParticipations(username) {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: USER_PARTICIPATIONS_LOAD_REQUEST });

    rest.doGet(`/admin/users?username=${username}`).then((user) => {
      dispatch({
        [TYPE_KEY]: USER_PARTICIPATIONS_LOAD_SUCCESS,
        [USER_PARTICIPATIONS]: user.participations || [],
        [EMPLOYEE_NUMBER]: user.employeeNumber || ""
      });
    });
  };
}

export function loadUserPermissionHistory(username) {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: USER_PERMISSION_HISTORY_LOAD_REQUEST, [USERNAME]: username });

    rest.doGet(`/admin/users?username=${username}&permissionHistory=true`).then(
      (history) => {
        dispatch({
          [TYPE_KEY]: USER_PERMISSION_HISTORY_LOAD_SUCCESS,
          [USER_PERMISSION_HISTORY]: history || []
        });
      },
      (reason) => {
        dispatch({ [TYPE_KEY]: USER_PERMISSION_HISTORY_LOAD_FAIL });
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function loadUsersParticipations(usernames) {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: USER_PARTICIPATIONS_BY_USER_LOAD_REQUEST });

    rest.doPost(`/admin/users/participations`, JSON.stringify({ usernames: usernames })).then((participations) => {
      dispatch({
        [TYPE_KEY]: USER_PARTICIPATIONS_BY_USER_LOAD_SUCCESS,
        [USER_PARTICIPATIONS_BY_USER]: participations || {}
      });
      dispatch(endLoading());
    });
  };
}

export function sendUserAccountNotification(user) {
  return (dispatch) => {
    const sendMail = (data) => {
      rest
        .doPost(`/authentication/users/action/senduseraccountnotification/${data.user.identifier}`, null)
        .then((json) => {
          if (json) {
            dispatch(loadUsers());
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
          }
        });
    };

    dispatch(
      showDialog(
        { user: user },
        sendMail,
        "confirmDialog.text",
        "user.management.edit.send.user.account.notification.confirm",
        "confirmDialog.ok",
        "confirmDialog.cancel"
      )
    );
  };
}
